import Vue from 'vue';
import Vuex from 'vuex';
import cart from './modules/cart';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    cart,
  },
  strict: debug,
  plugins: [vuexLocal.plugin],
});
